import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=2a19b074&scoped=true"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=2a19b074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a19b074",
  null
  
)

export default component.exports